import authAxios from "../common/authAxios";

class DormAccomodation {
  async getBenefits() {
    return await authAxios.get("/dormitory/get-privileges");
  }

  async submitDormApplication(data) {
    return await authAxios.post("/dormitory/create-application", data);
  }

  async updateDormApplication(data, applicationId) {
    return await authAxios.post(
      `/dormitory/update-application?applicationId=${applicationId}`,
      data
    );
  }

  async getApplication() {
    return await authAxios.get("/dormitory/get-application-by-username");
  }

  // Статус по общежитию
  async getDormStatus() {
    // id: Long
    // statusCode: Integer
    // description: String
    return await authAxios.get("/dormitory/get-status-by-username");
  }

  async getDormQueue() {
    return await authAxios.get("/dormitory/get-current-queue");
  }
}

export default DormAccomodation;
